<a
  [routerLink]="
    training().slug === 'madryt' || training().slug === 'singapur'
      ? ['/', training().slug]
      : [
          user() ? '/' + WwwRouteSlug.ACCOUNT : '/',
          training().training_type === TrainingType.TRAINING ? WwwRouteSlug.PRO_EDUCATION : WwwRouteSlug.PRO_EXPERIENCE,
          training().slug,
        ]
  "
  appGtmClick
  [layer]="{
    event: 'uaevent',
    ecommerce: 'undefined',
    eventCategory: 'trainings list',
    eventAction:
      'select::' +
      (training().slug === 'madryt' || training().slug === 'singapur' ? 'go to event::' : 'go to training::'),
    eventLabel:
      (training().slug === 'madryt' || training().slug === 'singapur' ? 'go to event::' : 'go to training::') +
        training().slug ===
        'madryt' || training().slug === 'singapur'
        ? ['/', training().slug]
        : [
            user() ? '/' + WwwRouteSlug.ACCOUNT : '/',
            training().training_type === TrainingType.TRAINING
              ? WwwRouteSlug.PRO_EDUCATION
              : WwwRouteSlug.PRO_EXPERIENCE,
            training().slug,
          ],
    event_name: 'body_button_click',
    module_name: 'go to training',
    cta_name: 'go to training',
    link_url:
      training().slug === 'madryt' || training().slug === 'singapur'
        ? '/' + training().slug
        : user()
          ? '/' + WwwRouteSlug.ACCOUNT
          : '/' + training().training_type === TrainingType.TRAINING
            ? WwwRouteSlug.PRO_EDUCATION
            : WwwRouteSlug.PRO_EXPERIENCE + training().slug,
  }"
>
  <div class="www-eve-tile">
    <img
      [alt]="training().list_photo"
      [ngSrc]="training().list_photo"
      class="www-eve-tile__img"
      width="426"
      height="442"
    />

    <h3 class="www-eve-tile__tit">{{ training().name }}</h3>

    @if (showPrice()) {
      <p class="www-eve-tile__price">
        @if (!!user()) {
          @if (training().price != 0) {
            <s>{{ training().price + ' PLN' }}</s>
          } @else {
            Szkolenie bezpłatne
          }
          &nbsp;{{
            training().price != 0
              ? user()?.type === UserType.MEMBER
                ? (training().price * 0.9 | mask: 'separator.2') + ' PLN'
                : (training().price * 0.8 | mask: 'separator.2') + ' PLN'
              : ''
          }}
        } @else {
          @if (training().price != 0) {
            {{ (training().price | mask: 'separator.2') + ' PLN' }}
          } @else {
            Szkolenie bezpłatne
          }
        }
      </p>
    }

    <div class="www-eve-tile__hov">
      <span class="www-eve-tile__hov__sm"> Pokaż więcej </span>
      <!-- <div class="www-eve-tile__hov__bar">
        {{ training().training_type === TrainingType.TRAINING ? 'PRO.EDUCATION' : 'PRO.EXPERIENCE' }}
      </div> -->
    </div>
  </div>
</a>
